import { Component, OnInit } from '@angular/core';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';

import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { callbackAdjustCA, callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-document-introduction',
  templateUrl: './document-introduction.component.html',
  styleUrls: ['./document-introduction.component.scss'],
})

/**
 * Clase del componente de introducción al escaneo del documento
 *
 * *Document introduction component class*
 *
 * @implements {OnInit}
 */
export class DocumentIntroductionComponent implements OnInit {
  postLogin: boolean;

  /**
   * Constructor of the component.
   *
   * @param {BioCatchService}   biocatchService   Injectable biocatchService service.
   * @param {AbreCuentasService}   abreCuentasService   Injectable AbreCuentasService service.
   * @param {HeaderService}     headerService     Injectable headerService service.
   * @param {NavigationService} navigationService Injectable navigationService service.
   * @function headerService.show() Hides header
   */
  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private biocatchService: BioCatchService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private bitacoraService: BitacoraService,
    private adjustEvent: AdjustEvent,
  ) {
    this.headerService.show(false, false, false);
  }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado
   *
   * *Angular function that is run when the component is loaded*
   */
  ngOnInit() {
    const productSelected = this.abreCuentasService.getproductSelected();
    if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
      const event = {
        eventToken: '6eg3s7',
        callbackParams: callbackAdjustCA,
      };
      this.adjustEvent.adjustTrackEvent(event);
    } else if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      const event = {
        eventToken: 'xx4m4g',
        callbackParams: callbackAdjustContratarTC,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.biocatchService.changeContext(StepBiocatchEnum.identificacion, product);
  }

  /**
   * Función para ir a la siguiente pantalla
   *
   * *Angular function that goes to the next step*
   */
  next() {
    const bitacoraEvent = 'Inicia_identificacion_SI';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.navigationService.nextStep();
  }
}
